// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/layout/ToC.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/layout/ToC.tsx");
  import.meta.hot.lastModified = "1773385375629.063";
}
// REMIX HMR END

import { Image } from "@unpic/react";
import React, { useEffect, useState } from "react";
import { ContentWrapper, Sidebar } from "~/components";
import { formatDate, formatTitleForTableOfContent } from "~/utils/utils";
import PageHeader from "../field/PageHeader";
import Heading from "../Heading";
import DropdownOfContent from "../TableOfContent/DropdownOfContent";
export default function ToC({
  node,
  children,
  layout
}) {
  _s();
  const [activeSection, setActiveSection] = useState({
    hash: "",
    name: ""
  });
  const [links, setLinks] = useState([]);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const intersectingEntries = entries.filter(entry => entry.isIntersecting);
      if (intersectingEntries.length === 0) {
        return;
      }
      if (intersectingEntries.length === 1) {
        const entry = intersectingEntries[0];
        const hash = entry.target.id;
        setActiveSection({
          hash: hash,
          name: entry.target.textContent || ""
        });
      }
      const mostVisibleEntry = intersectingEntries.reduce((prev, current) => {
        if (prev.intersectionRatio === current.intersectionRatio) {
          return prev.boundingClientRect.y < current.boundingClientRect.y ? prev : current;
        }
        return prev.intersectionRatio < current.intersectionRatio ? prev : current;
      });
      const hash = mostVisibleEntry.target.id;
      setActiveSection({
        hash: hash,
        name: mostVisibleEntry.target.textContent || ""
      });
    }, {
      rootMargin: "-80px 0px -80% 0px"
    });
    const searchSection = document.querySelector("#toc-content");
    if (searchSection) {
      const h2Elements = searchSection.querySelectorAll("h2");
      const h2Texts = Array.from(h2Elements).map(h2 => {
        observer.observe(h2);
        if (h2.textContent) {
          h2.id = formatTitleForTableOfContent(h2.textContent);
        }
        return h2.textContent;
      });
      setLinks(h2Texts);
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  const publishedDate = formatDate(node.created?.timestamp);
  const lastUpdate = formatDate(node.changed?.timestamp);
  return <main>
      <DropdownOfContent activeSection={activeSection} links={links} />

      {node.title && layout === "quaternary" && <PageHeader title={node.title}>
          <div className="self-center mt-4 w-fit text-base font-semibold divide-x-2">
            <address className="inline not-italic pr-2">
              By{" "}
              <span className="text-neutral-300" rel="author">
                {node.author?.fullName}
              </span>
            </address>
            <time dateTime={publishedDate} className="pl-2">
              {publishedDate}
            </time>
          </div>
        </PageHeader>}
      {node.title && layout === "tertiary" && <ContentWrapper spacing={layout} className="text-neutral-100 bg-gradient-primary animate-background-transition bg-400% px-4 pt-28 md:pt-36 lg:pt-20 !pb-0">
          <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-[10%]">
            <div className="flex justify-center flex-col">
              <div className="w-full max-w-[45ch]">
                <Heading tag="h1" className="!text-neutral-100">
                  {node.title}
                </Heading>
              </div>
              <div className="text-lg">
                <div className="pb-6">{node.abstract}</div>
                <address className="inline not-italic">
                  <span className="font-bold">Last update:</span>
                </address>
                <time dateTime={lastUpdate} className="pl-2">
                  {lastUpdate}
                </time>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <Image width={node.heroImage?.mediaImage.width} height={node.heroImage?.mediaImage.height} layout="constrained" className="object-scale-down w-full max-w-[500px] aspect-square" src={node.heroImage?.mediaImage.url} />
            </div>
          </div>
        </ContentWrapper>}
      <ContentWrapper className="bg-white px-4 py-14" spacing={layout}>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <aside className="hidden lg:block lg:col-span-1 top-40 sticky place-self-start">
            <Sidebar node={node} activeSection={activeSection.hash} links={links} />
          </aside>
          <article className="col-span-4 lg:col-span-3">{children}</article>
        </div>
      </ContentWrapper>
    </main>;
}
_s(ToC, "doTCbosPuRWrNtZMgUK3EyF3Cto=");
_c = ToC;
var _c;
$RefreshReg$(_c, "ToC");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;